export enum EnumOpenMiniProgramType {
  /** uc */
  Uc = 'uc',
  /** 展览 */
  Show = 'show',
  /** 文房 */
  Wenfang = 'wenfang',
  /** 日课 */
  DayCourse = 'daycourse',
  /** 山林曦照 */
  Arts = 'arts'
}

export enum EnumOpenMiniProgramPage {
  /** uc */
  Uc = 'pages/index/index',
  /** uc 小程序内容详情页 */
  UserContent = 'pages/homework/content/index',
  /** uc 小程序内容详情页 - 兼容视频 */
  UcVideoContent = '/pages/moments/videos/index',
  /** 展览 */
  Show = 'pages/index/index',
  /** 去备展 */
  ShowLevels = 'pages/levels/index',
  /** 去观展 */
  ShowLookingEx = 'pages/lookingEx/index',
  /** 文房 */
  Wenfang = 'pages/home/dashboard/index',
  /** 日课首页 */
  DayCourse = '',
  /** 山林曦照 */
  Arts = ''
}

export enum SDKErrCode {
  SUCCESS = 0,
  INVALID_ENVIRONMENT = 1,
  NETWORK_ERROR = 2,
  TICKET_ERROR = 3,
  INVALID_PARAMS = 4,
  SERVER_ERROR = 5,
  TIMEOUT = 6,
  UNKNOWN_ERROR = 7,
  RATE_LIMIT_EXCEEDED = 8,
  INVALID_API_NAME = -11028,
  TICKET_ERROR_V2 = -11029,
  INVALID_DOMAIN = -11032,
  HTTPS_REQUIRED = -11033,
  PERMISSION_DENIED = -11034,
  INVALID_REQUEST_METHOD = -11035,
  CLIENT_VERSION_NOT_SUPPORTED = -11036
}
